/** @format */

import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import withStyles from '@material-ui/core/styles/withStyles';
import adescomStyle from '../../../assets/jss/adescom/adescomStyle';
import { Card, Typography } from '@material-ui/core';
import CardHeader from '../../../components/Card/CardHeader';
import I18n from '../../../components/Translate/I18n';
import CardBody from '../../../components/Card/CardBody';
import ApiUri from '../../../interfaces/api/ApiUri';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import { provConstant, provReducer } from '../../../modules/provisioning/ProvisioningConnect';
import { store } from '../../../core/store';
import MvnoBlockRequest from '../../../interfaces/platform/MvnoBlockRequest';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import ApiBlockViewStateDetail from './ApiBlockViewStateDetail';

interface ApiBlockViewDetailProps {
    dispatch: any;
    classes: any;
    apiUri: ApiUri;
}

interface ApiBlockViewDetailState {
    mvnoBlockRequest: MvnoBlockRequest | null;
}

class ApiBlockViewDetail extends PureComponent<ApiBlockViewDetailProps, ApiBlockViewDetailState> {
    private loaderCall: ItemLoaders;

    constructor(props: ApiBlockViewDetailProps, context: ApiBlockViewDetailState) {
        super(props, context);
        this.state = {
            mvnoBlockRequest: null,
        };
        store.injectReducer('provReducer', provReducer, false);
        this.loaderCall = new ItemLoaders(this.props.dispatch);
    }

    componentDidMount(): void {
        const { apiUri } = this.props;
        this.loadMvnoBlockRequest(apiUri);
    }

    loadMvnoBlockRequest = (apiUri: ApiUri): void => {
        this.loaderCall.getWithCallback(
            FormGeneralHelper.getByUri(apiUri.uri),
            provConstant.MVNO_BLOCK_REQUEST_ITEM,
            (data: MvnoBlockRequest): void => {
                this.setState({
                    mvnoBlockRequest: data,
                });
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    render():
        | React.ReactElement<any, string | React.JSXElementConstructor<any>>
        | string
        | number
        | {}
        | React.ReactNodeArray
        | React.ReactPortal
        | boolean
        | null
        | undefined {
        const { mvnoBlockRequest } = this.state;
        const variant = 'body1';
        if (mvnoBlockRequest) {
            return (
                <Card>
                    <CardHeader>
                        <Typography variant={variant} color="primary">
                            <I18n trans="prov:api.api_block" valueObject={{ name: mvnoBlockRequest?.mvnoBlockListName }} />
                        </Typography>
                    </CardHeader>
                    <CardBody>
                        {mvnoBlockRequest && (
                            <React.Fragment>
                                <Typography variant={variant}>
                                    <I18n trans="prov:api.api_block_operation" />
                                </Typography>
                                <ApiBlockViewStateDetail item={mvnoBlockRequest} />
                            </React.Fragment>
                        )}
                    </CardBody>
                </Card>
            );
        }
        return null;
    }
}

const mapStateToProps = (state: any): object => {
    return { ...state };
};

export default compose<any, any>(connect(mapStateToProps), withStyles(adescomStyle))(ApiBlockViewDetail);
